import request from '@module/http/axios/request';

export default {
  send(keys, limit = 100) {
    const random = Math.random() * 100;
    if (random <= limit) {
      const qs = this.generateQueryString(keys);
      request({
        method: 'POST',
        path: `/csm?${qs}`,
      });
    }
  },

  generateQueryString(keys) {
    if (Array.isArray(keys)) {
      return keys.map((key) => `${key}=1`).join('&');
    }

    return `${keys}=1`;
  },
};
